
///Ading New Cycle
export const ADD_NEW_Payment = "ADD_NEW_Payment";
export const ADD_NEW_Payment_SUCCESS = "ADD_NEW_Payment_SUCCESS";
export const ADD_NEW_Payment_FAIL = "ADD_NEW_Payment_FAIL";
///////////////////////////////////////////////////

export const GET_PARTICIPANT_PAYMENT = "GET_PARTICIPANT_PAYMENT";
export const GET_PARTICIPANT_PAYMENT_SUCCESS = "GET_PARTICIPANT_PAYMENT_SUCCESS";
export const GET_PARTICIPANT_PAYMENT_FAIL = "GET_PARTICIPANT_PAYMENT_FAIL";


/////////////////////////////////////////////////////////////////////
export const GET_PARTICIPANT_SCHEME_LIST = "GET_PARTICIPANT_SCHEME_LIST";
export const GET_PARTICIPANT_SCHEME_LIST_SUCCESS = "GET_PARTICIPANT_SCHEME_LIST_SUCCESS";
export const GET_PARTICIPANT_SCHEME_LIST_FAIL = "GET_PARTICIPANT_SCHEME_LIST_FAIL";
/////////////////////////////////////////
  export const UPDATE_NEW_PAYMENT = "UPDATE_NEW_PAYMENT";
export const UPDATE_NEW_PAYMENT_SUCCESS = "UPDATE_NEW_PAYMENT_SUCCESS";
export const UPDATE_NEW_PAYMENT_FAIL = "UPDATE_NEW_PAYMENT_FAIL";
////////////////////////////////////////////////////////////
export const GET_DELETED_PAYMENTS = "GET_DELETED_PAYMENTS";
export const GET_DELETED_PAYMENTS_SUCCESS = "GET_DELETED_PAYMENTS_SUCCESS";
export const GET_DELETED_PAYMENTS_FAIL = "GET_DELETED_PAYMENTS_FAIL";
// ////////////////////////////////////////////////////////
export const DELETE_PAYMENT = "DELETE_PAYMENT";
export const DELETE_PAYMENT_SUCCESS = "DELETE_PAYMENT_SUCCESS";
export const DELETE_PAYMENT_FAIL = "DELETE_PAYMENT_FAIL";

//////////////////////////////////////////////////////////////
export const CONFIRM_PAYMENT = "CONFIRM_PAYMENT";
export const CONFIRM_PAYMENT_SUCCESS = "CONFIRM_PAYMENT_SUCCESS";
export const CONFIRM_PAYMENT_FAIL = "CONFIRM_PAYMENT_FAIL";

/////////////////////////////////////////////////////////////
export const GET_ANALYTE_REPORT2 = "GET_ANALYTE_REPORT2";
export const GET_ANALYTE_REPORT2_SUCCESS = "GET_ANALYTE_REPORT2_SUCCESS";
export const GET_ANALYTE_REPORT2_FAIL = "GET_ANALYTE_REPORT2_FAIL";

/////////////////////////////////////////////////////////////
export const GET_ANALYTE_EVALUATION_REPORT = "GET_ANALYTE_EVALUATION_REPORT";
export const GET_ANALYTE_EVALUATION_REPORT_SUCCESS = "GET_ANALYTE_EVALUATION_REPORT_SUCCESS";
export const GET_ANALYTE_EVALUATION_REPORT_FAIL = "GET_ANALYTE_EVALUATION_REPORT_FAIL";

export const GET_PARTICIPANT_PERFORMANCE_REPORT = "GET_PARTICIPANT_PERFORMANCE_REPORT";
export const GET_PARTICIPANT_PERFORMANCE_REPORT_SUCCESS = "GET_PARTICIPANT_PERFORMANCE_REPORT_SUCCESS";
export const GET_PARTICIPANT_PERFORMANCE_REPORT_FAIL = "GET_PARTICIPANT_PERFORMANCE_REPORT_FAIL";


/////////////////////////////////////////////////////////////
export const GET_ANALYTE_EVALUATION_LAB = "GET_ANALYTE_EVALUATION_LAB";
export const GET_ANALYTE_EVALUATION_LAB_SUCCESS = "GET_ANALYTE_EVALUATION_LAB_SUCCESS";
export const GET_ANALYTE_EVALUATION_LAB_FAIL = "GET_ANALYTE_EVALUATION_LAB_FAIL";

export const GET_FINANCIAL_FORECAST = "GET_FINANCIAL_FORECAST";
export const GET_FINANCIAL_FORECAST_SUCCESS = "GET_FINANCIAL_FORECAST_SUCCESS";
export const GET_FINANCIAL_FORECAST_FAIL = "GET_FINANCIAL_FORECAST_FAIL";